import React, { useContext, useEffect, useState } from 'react';
import Button from '../../components/ui/button';
import Text from '../../components/ui/text';
import { MicrocopyContext } from '../../context/microcopy.context';
import { getCopy } from '../../helpers/copy';
import { combine } from '../../helpers/styles';
import Container from '../../modules/container';
import * as styles from './cookieBanner.module.scss';
import DC_Bakery from './dc_bakery';

DC_Bakery.__init();
const CookieBanner = ({}) => {
  const [isClient, setIsClient] = useState(false);
  const [selection, setSelection] = useState([true, false, false]);
  const [cookieIsSet, setCookieIsSet] = useState(null);
  const microcopy = useContext(MicrocopyContext);

  const typesOfCookies = [
    'functionalCookies',
    'statisticalCookies',
    'marketingCookies',
  ];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsClient(true);
      setCookieIsSet(cookieExists('cookieConsent'));
    }
  }, []);

  useEffect(() => {
    if (!!cookieIsSet) {
      DC_Bakery.flush();

      if (cookieExists('statisticalCookies')) {
        const triggerGtmEvent = new Event('statisticalCookies', {
          bubbles: true,
          cancelable: false,
        });

        document?.dispatchEvent(triggerGtmEvent);
      }
      const triggerCookieEvent = new Event('cookieConsent', {
        bubbles: true,
        cancelable: false,
      });
      document?.dispatchEvent(triggerCookieEvent);
    }
  }, [cookieIsSet]);

  const changeSelection = (index) => {
    let state = [...selection];
    state[index] = !state[index];
    setSelection(state);
  };

  const writeCookie = async (selectAll = false) => {
    let selectedCookies = selection;
    if (selectAll) selectedCookies = [true, true, true];

    const status = selectedCookies[1] ? '1337' : '420';
    await fetch(`/images/${status}.gif?d=` + new Date().getTime());

    createCookie('cookieConsent');
    setCookieIsSet(true);

    selectedCookies.forEach(
      (cookie, index) => cookie && createCookie(typesOfCookies[index])
    );

    DC_Bakery.clean();
  };

  const createCookie = (cookie) => {
    const cookieDate = new Date();
    cookieDate.setFullYear(cookieDate.getFullYear() + 1);
    return (document.cookie = `${cookie}=true; expires=${cookieDate.toUTCString()}; path=/;`);
  };

  const cookieExists = (cookie) => {
    return document?.cookie?.indexOf(cookie) > -1;
  };

  return cookieIsSet !== null ? (
    !cookieIsSet ? (
      <Container data-nosnippet className={styles.cookieBanner}>
        <div className={styles.cookieBannerInner}>
          <Text className={styles.headline}>
            {getCopy('cookie.headline', microcopy)}
          </Text>
          <Text className={styles.text}>
            {' '}
            {getCopy('cookie.text1', microcopy)}
            <span
              dangerouslySetInnerHTML={{
                __html: getCopy('cookie.text2', microcopy),
              }}
            ></span>
          </Text>
          <form className={styles.formWrapper}>
            {typesOfCookies.map((type, index) => (
              <label
                className={styles.checkboxLabel}
                key={index}
                htmlFor={type}
              >
                <div className={styles.checkboxWrapper}>
                  <input
                    name={type}
                    id={type}
                    type="checkbox"
                    disabled={index === 0}
                    checked={selection[index]}
                    onChange={() => changeSelection(index)}
                  />
                  <span className={styles.slider}></span>
                </div>
                {getCopy(`cookie.${type}`, microcopy)}
              </label>
            ))}
          </form>
          <div className={styles.buttonContainer}>
            <Button
              type="link"
              className={combine(styles.button, styles.selectionButton)}
              text={getCopy('cookie.selection', microcopy)}
              onClick={() => writeCookie()}
              withoutTransform
            />
            <Button
              type="quaternary"
              className={combine(styles.button, styles.allButton)}
              text={getCopy('cookie.acceptAll', microcopy)}
              onClick={() => writeCookie(true)}
            />
          </div>
        </div>
      </Container>
    ) : (
      // add tracking stuff dynamically
      ''
    )
  ) : (
    ''
  );
};

CookieBanner.propTypes = {};

CookieBanner.defaultProps = {};

export default CookieBanner;
